/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Mistakestypeshortanswer3Inputs */

const zh_learn_mistakestypeshortanswer3 = /** @type {(inputs: Learn_Mistakestypeshortanswer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简答题`)
};

const en_learn_mistakestypeshortanswer3 = /** @type {(inputs: Learn_Mistakestypeshortanswer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short Answer`)
};

const es_learn_mistakestypeshortanswer3 = /** @type {(inputs: Learn_Mistakestypeshortanswer3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuesta corta`)
};

/**
* | output |
* | --- |
* | "Short Answer" |
*
* @param {Learn_Mistakestypeshortanswer3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakestypeshortanswer3 = /** @type {((inputs?: Learn_Mistakestypeshortanswer3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakestypeshortanswer3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakestypeshortanswer3(inputs)
	if (locale === "en") return en_learn_mistakestypeshortanswer3(inputs)
	return es_learn_mistakestypeshortanswer3(inputs)
});
export { learn_mistakestypeshortanswer3 as "learn_mistakesTypeShortAnswer" }